export default "__VITE_ASSET__Cyi9Jhzp__"